<div class="buttons-controls text-right">

    <div class="controls pull-right">

        <ng-content></ng-content>

    </div>


</div>